import { Component, forwardRef, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors, Validator, Validators } from '@angular/forms'

@Component({
    selector: 'app-pin-code-input',
    templateUrl: './pin-code-input.component.html',
    styleUrls: ['./pin-code-input.component.sass'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PinCodeInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PinCodeInputComponent),
            multi: true,
        }
    ],
})
export class PinCodeInputComponent implements AfterViewInit, ControlValueAccessor, Validator {

    @Input() maxLength = 10
    @Input() placeholder = 'Enter PIN'
    @Input() focusOnInit = true
    @ViewChild('hiddenInput') hiddenInput!: ElementRef<HTMLInputElement>

    value = ''
    showPin = false
    disabled = false
    touched = false
    focused = false

    private onChange = (_: string | null) => {}
    private onTouched = () => {}
    private onValidatorChange = () => {}

    get displayCharacters(): string[] {
        const chars = this.value.split('')
        const remaining = this.maxLength - chars.length
        return [...chars, ...Array(remaining).fill('')]
    }

    get displayValue(): string {
        if (this.showPin) {
            return this.value
        }
        return '•'.repeat(this.value.length)
    }

    ngAfterViewInit() {
        if (this.focusOnInit) {
            setTimeout(() => this.focusInput(), 0)
        }
    }

    onInput(event: Event) {
        const target = event.target as HTMLInputElement
        let newValue = target.value
        if (newValue.length > this.maxLength) {
            newValue = newValue.substring(0, this.maxLength)
            target.value = newValue
        }
        this.value = newValue
        this.onChange(this.value)
        this.onValidatorChange()
    }

    onFocus() {
        this.focused = true
    }

    onBlur() {
        this.focused = false
        this.touched = true
        this.onTouched()
    }

    focusInput() {
        if (this.hiddenInput && !this.disabled) {
            this.hiddenInput.nativeElement.focus()
        }
    }

    toggleShowPin() {
        this.showPin = !this.showPin
        if (this.focused) {
            setTimeout(() => this.focusInput(), 0)
        }
    }

    writeValue(value: string | null) {
        this.value = value || ''
    }

    registerOnChange(fn: (value: string | null) => void) {
        this.onChange = fn
    }

    registerOnTouched(fn: () => void) {
        this.onTouched = fn
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const required = control.hasValidator(Validators.required)
        if (required && (!this.value || this.value.length === 0)) {
            return { required: true }
        }
        return null
    }

    registerOnValidatorChange(fn: () => void) {
        this.onValidatorChange = fn
    }
}

